import GetIcon from "@/components/font-awesome-icon";
import UISwitch from "@/components/ui-controls/ui-switch";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons/faCircleInfo";
import { Box, FormHelperText, Tooltip, Typography } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import React, { useEffect, useState } from "react";

const DynamicSwitch = (props) => {
  const {
    title,
    value,
    name,
    onChange,
    onBlur,
    labelPlacement = "start",
    tooltip = "",
    defaultStyled = true,
    disabled = false,
    size = "medium",
    error,
  } = props;
  const [checked, setChecked] = useState();
  const handleChange = (event) => {
    const isChecked = event.target.checked;
    setChecked(event.target.checked);
    onChange({
      target: {
        value: isChecked,
      },
    });
  };
  useEffect(() => {
    setChecked(value);
  }, [value]);

  return (
    <>
      <Box className="d-flex align-items-center h-100 justify-content-space-between">
        <Box className="d-flex align-items-center">
          <Typography
            variant="body1"
            sx={{
              mr: 1,
              color: disabled
                ? "var(--palette-disabled_button_text)"
                : "var(--palette-text)",
            }}
          >
            {title}
          </Typography>
          {tooltip && (
            <Tooltip placement="top" title={tooltip}>
              <Typography color="custom.text">
                <GetIcon icon={faCircleInfo} />
              </Typography>
            </Tooltip>
          )}
        </Box>
        <FormControlLabel
          control={
            <UISwitch
              // id={item.field}
              size={size}
              checked={checked || false}
              onChange={handleChange}
              onBlur={onBlur}
              name={name}
              color="primary"
              defaultStyled={defaultStyled}
              disabled={disabled}
              sx={{
                width: 42,
                height: 24,
                borderRadius: 12,
                "& .Mui-disabled": {
                  opacity: "0.5 !important",
                  "& + .MuiSwitch-track": {
                    opacity: "0.1 !important",
                  },
                },
                "& .MuiSwitch-thumb": {
                  boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
                  width: 20,
                  height: 20,
                  borderRadius: 6,
                },
                "& .MuiSwitch-switchBase": {
                  padding: "2px",
                  "&.Mui-checked": {
                    transform: "translateX(18px)",
                    color: "#fff",
                    "& + .MuiSwitch-track": {
                      opacity: 1,
                      backgroundColor: "var(--palette-primary_button)",
                    },
                  },
                },
              }}
            />
          }
        />
      </Box>
      {error && <FormHelperText error>{error}</FormHelperText>}
    </>
  );
};
export default DynamicSwitch;
